export default {
  'menu.login': '登录',
  'menu.welcome': '欢迎',

  'menu.admin': '管理员管理',
  'menu.admin.admins': '管理员列表',
  'menu.admin.role': '角色管理列表',


  //合作方管理
  'menu.customer': '客户管理',
  'menu.customer.customerList': '客户列表',
  
  'menu.md5Query': 'md5 查询',
  'menu.md5Query.customerSearchQuotas': '客户搜索配额列表',
  'menu.md5Query.customerSearchRecord': '客户搜索记录列表',
  'menu.md5Query.customerSearchDayRecord': '客户搜索日记录列表',
  'menu.md5Query.customerSearchMonthRecord': '客户搜索月记录列表',

  'menu.carVerifyQuery': '有车核验查询',
  'menu.carVerifyQuery.carSearchQuotas': '有车搜索配额列表',
  'menu.carVerifyQuery.carSearchDayRecord': '有车搜索日记录列表',
  'menu.carVerifyQuery.carSearchMonthRecord': '有车搜索月记录列表',

  //号段管理
  'menu.phoneSegment': '号码归属地',
  'menu.phoneSegment.phoneSegmentList': '归属地列表',

  //项目数据管理
  'menu.carLoan': '车贷项目',
  'menu.carLoan.warehousing': '入库列表',
  'menu.carLoan.distributeTasks': '分发任务列表',
  'menu.carLoan.distributeDetail': '分发任务详情',
  'menu.carLoan.carLoanVerifyStatistics': '有车验证日统计',
}
